/** socket 事件 */
export var SocketServerMessage;
(function (SocketServerMessage) {
    SocketServerMessage["Chat_Info"] = "chat_info";
    SocketServerMessage["Robot_Im_Start_Chat_Info"] = "robot_im_start_chat_info";
    SocketServerMessage["Robot_Start_Chat_Info"] = "robot_start_chat_info";
    SocketServerMessage["Robot_Send_Msg_Res"] = "robot_send_msg_res";
    SocketServerMessage["Msg_Recv_Suc"] = "msg_recv_suc";
    SocketServerMessage["Msg_Recv_Error"] = "msg_recv_error";
    SocketServerMessage["Disconnect"] = "disconnect";
    SocketServerMessage["Connect"] = "connect";
    SocketServerMessage["Server_Msg"] = "server_msg";
    SocketServerMessage["Chat_End"] = "chat_end";
    /** 接收蹊径搜索组件场景下推送过来的推荐问题 */
    SocketServerMessage["Server_Recommend_Msg"] = "server_recommend_msg";
    // 连接错误
    SocketServerMessage["Connect_Error"] = "connect_error";
    // 连接超时
    SocketServerMessage["Connect_Timeout"] = "connect_timeout";
    // 尝试重试
    SocketServerMessage["Reconnect_Attempt"] = "reconnect_attempt";
})(SocketServerMessage || (SocketServerMessage = {}));
/**
 * socket client事件
 */
export var SocketClientEvent;
(function (SocketClientEvent) {
    SocketClientEvent["Start"] = "start";
    SocketClientEvent["Msg_Send"] = "msg_send";
    SocketClientEvent["Robot_Start"] = "robot_start";
    SocketClientEvent["Robot_Im_Start"] = "robot_im_start";
    SocketClientEvent["Robot_Answer_Msg_Send"] = "robot_answer_msg_send";
})(SocketClientEvent || (SocketClientEvent = {}));
export var SocketChannel;
(function (SocketChannel) {
    SocketChannel[SocketChannel["Robot"] = 0] = "Robot";
    SocketChannel[SocketChannel["Im"] = 1] = "Im";
})(SocketChannel || (SocketChannel = {}));
/** 进线时机（socket 连接时机） */
export var SocketConnectTiming;
(function (SocketConnectTiming) {
    /** 用户进入页面时 */
    SocketConnectTiming[SocketConnectTiming["Enter"] = 1] = "Enter";
    /** 用户发送第一条消息时 */
    SocketConnectTiming[SocketConnectTiming["FirstMessage"] = 2] = "FirstMessage";
    /** 智能进线 */
    SocketConnectTiming[SocketConnectTiming["Smart"] = 3] = "Smart";
})(SocketConnectTiming || (SocketConnectTiming = {}));
/** 回复的类型 */
export var MsgReplyType;
(function (MsgReplyType) {
    /** 客户 */
    MsgReplyType[MsgReplyType["Customer"] = 0] = "Customer";
    /** 客服 */
    MsgReplyType[MsgReplyType["Server"] = 1] = "Server";
    /** 机器人 */
    MsgReplyType[MsgReplyType["Robot"] = 2] = "Robot";
    /** im工具发送的系统消息 */
    MsgReplyType[MsgReplyType["ImSystem"] = 3] = "ImSystem";
    /** fmc系统消息(推荐问题回复) */
    MsgReplyType[MsgReplyType["FmcSystem"] = 4] = "FmcSystem";
    /** 填写离线留言表格 */
    MsgReplyType[MsgReplyType["MessageForm"] = 5] = "MessageForm";
})(MsgReplyType || (MsgReplyType = {}));
/**
 * 目前离线消息字段为leave_msg_type和msg_content，只有leave_msg_type=1的消息类型
 *
 * 类型为1的字段是customer_name,customer_phone,customer_leave_msg
 *
 * msg_type=5 msg_content为json串
 */
export var MessageMsgType;
(function (MessageMsgType) {
    /** 文本消息 */
    MessageMsgType[MessageMsgType["Text"] = 1] = "Text";
    /** 图片消息 */
    MessageMsgType[MessageMsgType["Image"] = 2] = "Image";
    /** 富文本消息 */
    MessageMsgType[MessageMsgType["Rich"] = 3] = "Rich";
    /** 系统消息 */
    MessageMsgType[MessageMsgType["System"] = 4] = "System";
    /** 离线消息 */
    MessageMsgType[MessageMsgType["Offline"] = 5] = "Offline";
})(MessageMsgType || (MessageMsgType = {}));
export var MessageMsgFrom;
(function (MessageMsgFrom) {
    /** MSG_FORM_GUEST */
    MessageMsgFrom[MessageMsgFrom["Customer"] = 0] = "Customer";
    /** MSG_FORM_STAFF */
    MessageMsgFrom[MessageMsgFrom["Server"] = 1] = "Server";
    /** fmc发送给客服的机器人消息 MSG_FORM_FMC_ROBOT */
    MessageMsgFrom[MessageMsgFrom["FmcRobot"] = 2] = "FmcRobot";
    /** 客服发送给fmc的系统消息 MSG_FROM_STAFF_SYSTEM */
    MessageMsgFrom[MessageMsgFrom["ServerSystem"] = 3] = "ServerSystem";
    /** fmc发送给客服的系统消息 MSG_FORM_FMC_SYSTEM */
    MessageMsgFrom[MessageMsgFrom["FmcSystem"] = 4] = "FmcSystem";
})(MessageMsgFrom || (MessageMsgFrom = {}));
export var MessageType;
(function (MessageType) {
    /** 客服 */
    MessageType[MessageType["Server"] = 1] = "Server";
    /** 客户 */
    MessageType[MessageType["Customer"] = 2] = "Customer";
    /** 系统消息-再见 */
    MessageType[MessageType["SystemBye"] = 3] = "SystemBye";
    /** 系统消息-自定义 */
    MessageType[MessageType["SystemCustom"] = 4] = "SystemCustom";
    /** 填写离线留言表格 */
    MessageType[MessageType["OfflineForm"] = 5] = "OfflineForm";
    /** 推荐问题 */
    MessageType[MessageType["QuestionRecommen"] = 6] = "QuestionRecommen";
    /** 表单预约 */
    MessageType[MessageType["FormOrder"] = 7] = "FormOrder";
    /** 蹊径卡片 */
    MessageType[MessageType["XjCard"] = 8] = "XjCard";
    /** 欢迎语图片 */
    MessageType[MessageType["WelcomeImage"] = 9] = "WelcomeImage";
    /** 医疗卡片温馨提示 */
    MessageType[MessageType["MedicaleTips"] = 10] = "MedicaleTips";
    /** 离线一键发送电话卡 */
    // OfflineOneButtonSIM = 11,
    /** 新医疗表单 */
    MessageType[MessageType["MedicaleForm"] = 13] = "MedicaleForm";
    /** 自助咨询表单 */
    MessageType[MessageType["SelfConsultForm"] = 14] = "SelfConsultForm";
    /** 快速电话 */
    MessageType[MessageType["QuickPhoneForm"] = 15] = "QuickPhoneForm";
    // 下面为本次新增 将XjCard 拆分
    /** 医院卡片 */
    MessageType[MessageType["HospitalCard"] = 16] = "HospitalCard";
    /** 疾病卡片 */
    MessageType[MessageType["DiseaseCard"] = 17] = "DiseaseCard";
    /** 活动卡片 */
    MessageType[MessageType["ActivityCard"] = 18] = "ActivityCard";
    /** 审核占位符 */
    MessageType[MessageType["Placeholder"] = 19] = "Placeholder";
    /** 医生卡片 */
    MessageType[MessageType["DoctorCard"] = 20] = "DoctorCard";
    /** 非搜索问题推荐 */
    MessageType[MessageType["BusinessCard"] = 21] = "BusinessCard";
    /** 系统提示 - 历史消息分割 */
    MessageType[MessageType["SystemHistory"] = 22] = "SystemHistory";
    /** 搜索词预输入 */
    MessageType[MessageType["SearchTerm"] = 23] = "SearchTerm";
    /** 历史消息占位 */
    MessageType[MessageType["HistoryCard"] = 24] = "HistoryCard";
})(MessageType || (MessageType = {}));
export var ChatStatus;
(function (ChatStatus) {
    /** 正常 */
    ChatStatus[ChatStatus["Normal"] = 0] = "Normal";
    /** 离线 */
    ChatStatus[ChatStatus["Offline"] = 1] = "Offline";
    /** 排队 */
    ChatStatus[ChatStatus["InLine"] = 2] = "InLine";
})(ChatStatus || (ChatStatus = {}));
